import Logo from '../assets/shared/logo.svg';
import Hamburger from '../assets/shared/icon-hamburger.svg';
import moon from '../assets/destination/image-moon.png';
import Close from '../assets/shared/icon-close.svg';




const Images = {
    Logo,
    Hamburger,
    moon,
    Close
}

export default Images;